import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calendar-event" }
const _hoisted_2 = ["href", "title"]
const _hoisted_3 = { class: "calendar-event__content" }
const _hoisted_4 = { class: "calendar-event__header" }
const _hoisted_5 = { class: "calendar-event__header-text" }

import { t } from '@nextcloud/l10n'
import IconReload from 'vue-material-design-icons/Reload.vue'
import StaticDateTime from './StaticDateTime.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarEventSmall',
  props: {
    name: {},
    start: {},
    color: {},
    isRecurring: { type: Boolean },
    href: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(["calendar-event__item", { 'calendar-event__item--thumb': !__props.href }]),
      href: __props.href,
      title: _unref(t)('spreed', 'Open Calendar'),
      tabindex: 0,
      target: "_blank"
    }, [
      _createElementVNode("span", {
        class: "calendar-event__badge",
        style: _normalizeStyle({ backgroundColor: __props.color })
      }, null, 4),
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.name), 1),
          (__props.isRecurring)
            ? (_openBlock(), _createBlock(IconReload, {
                key: 0,
                size: 13
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(StaticDateTime, {
          time: __props.start,
          calendar: ""
        }, null, 8, ["time"])
      ])
    ], 10, _hoisted_2)
  ]))
}
}

})